// Not part of the ES2023 lib, but present in every runtime this package runs in.
declare const performance: { now() : number };

/**
 * Milliseconds since the epoch, on the one clock that the page and its workers share. For times
 * that cross threads and for display. `performance.timeOrigin + performance.now()` is not such a
 * clock: every thread fixes its origin when it starts, and the two then disagree by whatever the
 * system clock was corrected in between (85 ms seen on macOS for a Worker started 14 minutes
 * after its page). The price is a resolution of 1 ms and a jump when the system clock is set.
 */
export const wallNow = () : number => Date.now();

/** Milliseconds on a clock that never jumps. For durations inside one thread, like the watchdog's. */
export const monotonicNow = () : number => performance.now();
